// tienda/CoberturaSection.jsx
// Coverage section: 4 KPI cards + searchable district list.

import React from "react";
import { motion } from "framer-motion";
import { Truck, Clock, CheckCircle2, HandCoins } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";
import { CoverageList } from "./CoverageList";

const KPIS = [
  { label: "Tarifa",          value: "Fija en cobertura", icon: <Truck className="size-4"/>,        color: brand.primary },
  { label: "Corte mismo día", value: "12:00 PM",          icon: <Clock className="size-4"/>,        color: brand.accentGold },
  { label: "Entrega",         value: "Antes de 8:00 PM",  icon: <CheckCircle2 className="size-4"/>, color: brand.accentGreen },
  { label: "Contraentrega",   value: "Disponible",        icon: <HandCoins className="size-4"/>,    color: brand.primary },
];

export function CoberturaSection() {
  return (
    <section id="cobertura" className="border-b border-slate-100 bg-white scroll-mt-16">
      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <motion.h2 {...fadeUp} className="text-2xl font-extrabold mb-8" style={{ color: brand.primary }}>
          Cobertura Lima Metropolitana & Callao
        </motion.h2>

        <div className="grid gap-6 md:grid-cols-2 md:items-start">
          {/* KPI cards + copy */}
          <div className="rounded-2xl border border-slate-100 bg-slate-50 p-5">
            <div className="grid grid-cols-2 gap-3 mb-4">
              {KPIS.map(k => (
                <div key={k.label} className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2">
                  <span
                    className="grid size-7 place-items-center rounded-lg shrink-0"
                    style={{ background: k.color + "15", color: k.color }}
                  >
                    {k.icon}
                  </span>
                  <div>
                    <div className="text-[10px] text-slate-400">{k.label}</div>
                    <div className="text-xs font-semibold text-slate-800">{k.value}</div>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Pedidos ingresados antes de <strong>12:00 PM</strong> se entregan{" "}
              <strong>el mismo día</strong> antes de las <strong>8:00 PM</strong>.
              Clientes Proveedores tienen corte hasta las <strong>3:00 PM</strong>.
            </p>
          </div>

          {/* Searchable district list */}
          <CoverageList />
        </div>
      </div>
    </section>
  );
}